<template>
  <a-card title="Create Product Group">
    <a-row :loading="preload">
      <a-col>
        <a-form-model ref="setting"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 12 }"
          :model="form">
          <a-form-item label="Name" ref="name">
            <a-input placeholder="Name" v-model="form.name">
            </a-input>
          </a-form-item>
          <a-form-model-item label="Description" ref="description">
            <a-input type="textarea" placeholder="Description" v-model="form.description">
            </a-input>
          </a-form-model-item>

          <a-form-model-item :wrapper-col="{ offset: 4 }">
            <a-button type="primary" html-type="submit" class="login-form-button" @click="save" :loading="submitting">
              Save
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import rules from './create-product-group-rules';

export default {
  name: "create-product-group",
  props: {
    group: {
      type: Object,
      default: null,
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules,
      item: {
        loading: false,
        product: {}
      },
      submitting: false,
      preload: false,
      form: {
        name: '',
        description: ''
      }
    }
  },
  created() {
    if (this.edit) {
      this.form.name = this.group.name
      this.form.description = this.group.description
      this.preload = true
    }
  },
  methods: {
    save() {
      this.$refs.setting.validate(valid => {
        if (valid) {
          if (this.edit) {
            this.editProductGroup()
          } else {
            this.createProductGroup()
          }
        } else {

        }
      })
    },
    createProductGroup() {
      this.submitting = true
      this.$http.post(this.routeUri('hyperion.product-group.store'), this.form)
        .then(res => this.handleSuccessResponse(res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => (this.submitting = false))
    },
    editProductGroup() {
      this.submitting = true
      this.$http.put(this.routeUri('hyperion.product-group.update', {product_group_hash: this.group.hash}), this.form)
        .then(res => this.handleSuccessResponse(res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => (this.submitting = false))
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Success",
        description: "You will be redirected in a few moment."
      })

      setTimeout(() => window.location.href = data.redirect, 3000)
    }
  }
}
</script>

<style scoped>

</style>
